"use client";
import { jsxs as c, jsx as e } from "react/jsx-runtime";
import { SelectRoot as i, SelectTrigger as u, SelectValue as m } from "../../atoms/Select/Select.mjs";
import { cn as k } from "../../../utils/utils.mjs";
const g = ({
  className: r,
  children: t,
  iconPrefix: a,
  iconSuffix: d,
  placeholder: l,
  selectTriggerProps: n,
  selectValueProps: o,
  ...s
}) => /* @__PURE__ */ c(i, { ...s, children: [
  /* @__PURE__ */ e(
    u,
    {
      iconPrefix: a,
      iconSuffix: d,
      className: k(
        "min-w-38 p-4 rounded-sm dark:bg-neutral-dark-200 dark:hover:not-disabled:bg-neutral-dark-400 dark:text-neutral-dark-1000 disabled:dark:text-neutral-dark-600",
        r
      ),
      ...n,
      children: /* @__PURE__ */ e(m, { placeholder: l, ...o })
    }
  ),
  t
] });
export {
  g as SelectInput
};
